import React, { useEffect } from 'react';
import { ensureGoogleLoaded, initGoogleAuth } from './googleClient';

/**
 * Renders the Google sign-in button and enables silent auto sign-in.
 * When the user is already signed in to Google (and has previously consented),
 * Google's One Tap will return a fresh credential automatically — no click needed.
 */
const GoogleAuth = ({ onSignIn, isSignedIn }) => {
  useEffect(() => {
    if (isSignedIn) return;
    let cancelled = false;

    ensureGoogleLoaded().then(() => {
      if (cancelled) return;
      initGoogleAuth(onSignIn);

      const buttonElement = document.getElementById('google-signin-button');
      if (buttonElement && window.google) {
        window.google.accounts.id.renderButton(buttonElement, {
          theme: 'outline',
          size: 'large',
          text: 'signin_with',
          locale: 'he',
        });
      }

      // Attempt silent / one-tap sign-in (no UI if it succeeds automatically)
      if (window.google) {
        window.google.accounts.id.prompt();
      }
    });

    return () => { cancelled = true; };
  }, [isSignedIn, onSignIn]);

  return <div id="google-signin-button"></div>;
};

export default GoogleAuth;
